import { Col, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import CustomCard from '../../../v2-components/Antd/Card';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomLink from '../../../v2-components/Antd/Link';
import CustomSwitch from '../../../v2-components/Antd/Switch';
import useSearchStore from '../../../v2-components/Search/store/useSearchStore';
import { platformNames } from '../constants/platform-names.contants';
import { nameAdapter } from '../create/handle/name-adapter.handle';
import { useAdminCarouselStore } from '../store/useCarouselStore';
import { Service } from './service';
import './style.scss';

export default function CarouselDetailAdminPage() {
	const [setProducts] = useSearchStore((state) => [state.setProducts]);
	const [pharmacy, root_pharmacy, data, platform, setData, setCurrentInfo, setOriginProducts] = useAdminCarouselStore((state) => [
		state.pharmacy,
		state.root_pharmacy,
		state.data,
		state.platform,
		state.setData,
		state.setCurrentInfo,
		state.setOriginProducts,
	]);

	const history = useHistory();

	const handleClickCard = (position) => {
		setCurrentInfo(data[position]);
		if (data[position]?.products?.length > 0) {
			new Service()
				.getProducts(data[position]?.products.toString())
				.then((response) => {
					console.log('response', response);
					setProducts(response);
					setOriginProducts(response);
				})
				.catch((error) => {
					console.log('error', error);
				});
		} else {
			setProducts([]);
			setOriginProducts([]);
		}
		history.push('/admin-carousel/create');
	};

	const handleSwitchChange = (status, position) => {
		const body = {
			isPageActive: status,
			status: status,
		};
		new Service()
			.updateIsPageActive(body, data[position]._id)
			.then((response) => {
				const updatedData = data.slice();
				updatedData[position].isPageActive = status;
				updatedData[position].status = status;

				setData(updatedData);
			})
			.catch((error) => console.log('error', error));
	};

	return (
		<div className="admin-carousel-page">
			<h1>
				{nameAdapter(root_pharmacy)} / {data?.length > 1 || platform === platformNames.ecc ? 'Home' : `Corner ${pharmacy.toUpperCase()}`}
			</h1>
			<CustomLink to={`/admin-carousel`}>{`Volver a ${nameAdapter(root_pharmacy)}
    `}</CustomLink>
			<h2>Seleccionar módulo a editar</h2>
			<Row>
				<Col md={6} xs={24}>
					<CustomCard
						onClick={() => {
							handleClickCard(0);
						}}
						className="carousel-cards"
						title={
							<div className="carousel-card-header-container">
								<h3>Carrousel de productos 1</h3>
								<div className="inner-container">
									<p>{data[0]?.products?.length > 0 ? `${data[0]?.products?.length} Productos` : 'Vacio'}</p>
								</div>
							</div>
						}
					>
						<CustomImage
							preview={false}
							src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
							alt="img"
						/>
					</CustomCard>
					<CustomSwitch
						checked={data[0]?.status}
						className={'switch'}
						onChange={(e) => {
							handleSwitchChange(e, 0);
						}}
					/>
				</Col>
				{pharmacy === platformNames.pharol && (
					<Col md={6} xs={24}>
						<CustomCard
							onClick={() => {
								handleClickCard(1);
							}}
							className="carousel-cards"
							title={
								<div className="carousel-card-header-container">
									<h3>Carrousel de productos 2</h3>
									<div className="inner-container">
										<p>{data[1]?.products?.length > 0 ? `${data[1]?.products?.length} Productos` : 'Vacio'}</p>
									</div>
								</div>
							}
						>
							<CustomImage
								preview={false}
								src={'https://storage.googleapis.com/tirx-resources-production/6c5f1634-3050-4abd-b943-34523b61bd47.webp'}
								alt="img"
							/>
						</CustomCard>
						<CustomSwitch
							className={'switch'}
							checked={data[1]?.status}
							onChange={(e) => {
								handleSwitchChange(e, 1);
							}}
						/>
					</Col>
				)}
			</Row>
		</div>
	);
}
